<template>
    <section class="map-section bg-light position-relative set-height100">
        <div class="container-fluid set-absolute">
            <div class="container">
                <div class="row justify-content-center company-teaser">
                  <h2 class="col-12 col-lg-9 col-xl-12 text-center">{{ $t('formation.map.title') }}</h2>
                  <p class="col-md-10 formation-map-content">
                    {{ $t('formation.map.content.text') }}
                    <ul class="formation-map-content-list">
                      <li>{{ $t('formation.map.content.time')}}</li>
                      <li>{{ $t('formation.map.content.selection')}}</li>
                      <li>{{ $t('formation.map.content.experts')}}</li>
                      <li>{{ $t('formation.map.content.simplify')}}</li>
                    </ul>
                  </p>
                </div>
                <div class="row justify-content-center company-informations">
                    <div class="col-md-6 d-flex justify-content-center">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10490.935854154362!2d2.3460010068678474!3d48.901407051897266!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66ef38142412f%3A0xe0889e40d36e75dc!2s54+Rue+des+Entrep%C3%B4ts%2C+93400+Saint-Ouen!5e0!3m2!1sfr!2sfr!4v1432741909676"
                            class="map"
                        >
                        </iframe>
                    </div>
                    <div class="col-md-6 col-lg-5 company-contact">
                        <p class="row adress">
                            <span class="col-2"><i class="fas fa-map-marker-alt"></i></span>
                            <span class="col-10">{{ $t('formation.map.address') }}</span>
                        </p>
                        <p class="row tel">
                            <span class="col-2"><i class="fas fa-phone"></i></span>
                            <span class="col-10">
                                <span>{{ $t('formation.map.phone') }}</span>
                                <span>{{ $t('formation.map.fax') }}</span>
                            </span>
                        </p>
                        <p class="row email">
                            <span class="col-2"><i class="fas fa-envelope"></i></span>
                            <span class="col-10">{{ $t('formation.map.mail') }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
.map{
    border: 1px solid #1A2050;
    width: 80%;
    height: 400px;
    margin-bottom: 2rem;
}
.fas{
    font-size: 1.5rem;
    color: #E65011;
}
.company-teaser{
    padding-bottom: 5rem;
    color: #1A2050;
    padding-top: 2rem;
}
.company-contact p{
    font-size: 1rem;
    padding-bottom: 1.5rem;
}
.company-contact .tel span:last-child{
    display: block;
}
.formation-map-content{
  padding-top: 3rem;
}
.formation-map-content-list{
  padding: revert;
}
.formation-map-content-list li{
  list-style-type: disc;
}
@media (min-width: 576px) {
    .container{
        max-width: 540px;
    }
}
@media (min-width: 768px) {
    .container{
        max-width: 720px;
    }
}
@media (min-width: 992px) {
    .set-height100 {
        height: 100vh;
    }
    .map-section .set-absolute{
        position:absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .container{
        max-width: 960px;
    }
    .company-contact p{
        font-size: 1.2rem;
        padding-bottom: 3rem;
    }

}
@media (min-width: 1200) {
    .container{
        max-width: 1140;
    }
}
@media (min-width: 1400px) {
    .container{
        max-width: 1320px;
    }
}
</style>
